module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_ashikari_sm-096e798f235192bf92fcec9c877e95db.png";